// placeholder/placeholdercommand.js

import Command from '@ckeditor/ckeditor5-core/src/command';

export default class PlaceholderCommand extends Command {
    execute( { value } ) {
        const editor = this.editor;
        const selection = editor.model.document.selection;

        editor.model.change( writer => {

            // Create a <placeholder> element with the "name" attribute (and all the selection attributes)...
            const placeholder = writer.createElement( 'placeholder', {
                ...Object.fromEntries( selection.getAttributes() ),
                name: value
            } );

            let placeholderObject = JSON.parse(JSON.stringify(placeholder))

            // if qr code placeholder is selected we need to insert image, not text placeholder
            if (placeholderObject.attributes.name === 'qr.code') {
                const docFrag = editor.model.change( writer => {
                    let selectedImages = ['/QR_code_placeholder.png'];
                    const docFrag = writer.createDocumentFragment();
                    for(let i=0;i<selectedImages.length;i++){
                        let imageElement = writer.createElement( 'image', {
                            src: selectedImages[i],
                            width: 300,
                            height: 300,
                            alignment: 'center'
                        } );
                        writer.append(imageElement, docFrag);
                    }

                    return docFrag;
                } );

                editor.model.insertContent( docFrag, editor.model.document.selection);
                writer.setSelection( docFrag, 'on' );

            } else {
                editor.model.insertContent( placeholder );
                writer.setSelection( placeholder, 'on' );
            }

        } );
    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;

        const isAllowed = model.schema.checkChild( selection.focus.parent, 'placeholder' );

        this.isEnabled = isAllowed;
    }
}